// SidebarFlyout.jsx
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { NavItem, NavLink, Nav } from "reactstrap";
import { NavLink as NavLinkRRD } from "react-router-dom";

export default function SidebarFlyout({ items, anchorRect, sidebarWidth = 72, onClose }) {
  const boxRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!boxRef.current?.contains(e.target)) onClose?.();
    };
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  if (!anchorRect) return null;

  const top = window.scrollY + anchorRect.top;
  const left = window.scrollX + anchorRect.left + sidebarWidth - 4; // แนบ sidebar

  return createPortal(
    <div
      ref={boxRef}
      role="menu"
      tabIndex={-1}
      style={{
        position: "absolute",
        top,
        left,
        minWidth: 220,
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 6px 20px rgba(0,0,0,.12)",
        padding: 8,
        zIndex: 1040,
      }}
    >
      <Nav vertical className="m-0">
        {items.map((child, i) => (
          <NavItem key={i}>
            <NavLink
              to={child.path}
              tag={NavLinkRRD}
              onClick={onClose}
              className="d-flex align-items-center py-2 px-3"
              style={{ borderRadius: 8, fontWeight: 600 }}
            >
              <span className="nav-text">{child.name}</span>
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    </div>,
    document.body
  );
}
